import React from 'react';
import ForcePlateTemplateModals from './ForcePlateTemplateModals';
import KPITrackerTemplateModals from './KPITrackerTemplateModals';
import LoadMonitoringTemplateModals from './LoadMonitoringTemplateModals';
import VolumeTrackerTemplateModals from './VolumeTrackerTemplateModals';
import VBTTemplateModals from './VBTTemplateModals';

const TemplateModals = () => (
  <>
    <ForcePlateTemplateModals />
    <KPITrackerTemplateModals />
    <LoadMonitoringTemplateModals />
    <VolumeTrackerTemplateModals />
    <VBTTemplateModals />
  </>
);

export default TemplateModals;
